import { styled } from '@mui/material';

import { Sidebar } from '@app-velocity/ui';

import { CurrentUserWidget } from '@app-velocity/libs/shared';

import { useTokenClaims } from '@app-velocity/request-gateway';

import { OpenIcon } from '@app-velocity/icons';

import { ReportDetails } from './components/Details';
import { Navigation } from './components/Navigation';
import { Participants } from './components/Participants';
import { ConfidenceLevel } from './components/ConfidenceLevel';
import { SimulationNotification } from './components/SimulationNotification';
import { BackLink } from './components/BackLink';
import { FeaturePreviewToggle } from './components/FeaurePreviewToggle';
import { useReportContext } from '../../context/useReportContext';

const Bottom = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
  marginTop: 'auto',
  padding: theme.spacing(4),
}));

export const ReportSidebar = () => {
  const readTokenClaim = useTokenClaims();
  const userId = readTokenClaim('sub')?.toString();
  const isSuperAdmin = readTokenClaim('superAdmin');
  const { simulationURL } = useReportContext();

  return (
    <>
      {userId ? (
        <>
          <CurrentUserWidget />
          <Sidebar.Separator />
          <BackLink />
        </>
      ) : null}

      <Sidebar.Separator />
      <ReportDetails />
      <Sidebar.Separator />
      {simulationURL ? (
        <>
          <Sidebar.Navigation
            items={[
              {
                label: 'prototypes:view_simulation',
                icon: <OpenIcon />,
                path: simulationURL,
              },
            ]}
          />
          <Sidebar.Separator />
        </>
      ) : null}
      <Navigation />
      <Sidebar.Separator />
      <Participants />
      <Bottom>
        {isSuperAdmin ? <FeaturePreviewToggle /> : null}
        <SimulationNotification />
        <ConfidenceLevel />
      </Bottom>
    </>
  );
};
